module.exports = __webpack_public_path__ + "fonts/Mukta-300-latin-ext5.78c11a5.woff2";